const angular = require('angular')
const keys = require('lodash/keys')
const size = require('lodash/size')

module.exports = ['$q', '$utils', '$translate', 'User', 'mailService', 'Promise', '$rootScope', 'IndexedDB',
  function ($q, $utils, $translate, User, mailService, Promise, $rootScope, IndexedDB) {
    function _initMailBody(options, mail) {
      if (mail.isAudit) {
        // 如果是审核邮件，内容需要重新组装
        options.part = '2'
        mailService.readMessage(options).then(function (res) {
          const header = '<pre style="font-size:14px;color:#222222;">------- 原邮件信息 -------</pre><br>'
          const cc = res.cc ? `<div style="margin: 6px 0;">${$translate.instant('MAIL.CC')}：${formatEmailLink(res.cc).join('；')}</div>` : ''
          const bcc = res.bcc ? `<div style="margin: 6px 0;">${$translate.instant('MAIL.BCC')}：${formatEmailLink(res.bcc).join('；')}</div>` : ''
          const content = `${header}<div style="margin: 6px 0;">${$translate.instant('MAIL.FROM')}：${formatEmailLink(res.from)[0]}</div>
                     <div style="margin: 6px 0;">${$translate.instant('MAIL.SENT_DATE')}：${res.sentDate}</div>
                     <div style="margin: 6px 0;">${$translate.instant('MAIL.TO')}：${formatEmailLink(res.to).join('；')}</div>
                     ${cc}${bcc}
                     ${$translate.instant('MAIL.SUBJECT')}：${res.subject}<br><br>
                     ${(res.html && res.html.content) || ''}<br><br>`
          mail.mailContent = content
          mail.attachments = mail.attachments.concat(res.attachments)
          mail.recipient = res.to
          mail.cc = res.cc
          mail.bcc = res.bcc
          mail.realSubject = res.subject
          mail.beAudited = res.from
          mail.guestSender = mail.antispamInfo ? mail.antispamInfo.GuestSender : ''
          mail.sender = mail.headers && angular.isArray(mail.headers['Sender']) ? mail.headers['Sender'][0] : ''
          mail.isGuestSenderMode = mail.guestSender && mail.sender && mail.guestSender.indexOf(mail.sender) !== -1
          commonDeal(options, mail)
        })
      } else {
        mail.mailContent = _getMailContent(mail)
        commonDeal(options, mail)
      }

      return mail
    }

    function commonDeal(options, mail) {
      // 该信件是否由共享邮箱代表发送模式发出
      mail.guestSender = mail.antispamInfo ? mail.antispamInfo.GuestSender : ''
      mail.sender = mail.headers && angular.isArray(mail.headers['Sender']) ? mail.headers['Sender'][0] : ''
      mail.isGuestSenderMode = mail.guestSender && mail.sender && mail.guestSender.indexOf(mail.sender) !== -1

      // 普通加密邮件  （参考XT3）
      if (mail.attachments[0] && mail.attachments[0].contentType == 'application/x-cm-encrypted') {
        mail.mailCipherEncrypted = true
      }

      _formatAttachments(options, mail.attachments)
      if (mail.calendar) {
        _formatCalendar(mail.calendar)
      }
    }

    function formatEmailLink(data) {
      const entireMailFormat = '\\<([^()]+)\\>'
      const res = data.map((ele) => {
        if (ele.match(new RegExp(entireMailFormat))) {
          const value = ele.match(new RegExp(entireMailFormat))[1]
          ele = ele.replace(value, `<a href="mailto:${value}">${value}</a>`)
        } else {
          ele = `<a href="mailto:${ele}">${ele}</a>`
        }
        return ele
      })
      return res
    }

    // 邮件正文内容
    function _getMailContent(content) {
      const textContent = content.text || ''
      const htmlContent = content.html || ''

      if (textContent) {
        textContent.content = '<pre style="word-wrap:break-word;" wrap="soft">' + $utils.$html.encode(textContent.content || '') + '</pre>'
      }
      return htmlContent ? htmlContent.content : textContent.content
    }

    //  邮件附件
    function _formatAttachments(options, attachments) {
      // console.log('options', options, attachments)
      const mid = options.id
      const mboxa = options.mboxa
      const mailCipherPassword = options.mailCipherPassword
      if (attachments && attachments.length > 0) {
        for (let i = 0; i < attachments.length; i++) {
          const attachment = attachments[i]
          attachment.path = mid
          attachment.filename = attachment.filename || 'Unknown'
          // attsize 精确大小(新加)， estimateSize 预估大小，contentLength 精确大小
          attachment.formatsize = $utils.$size.format(attachment.attsize || attachment.estimateSize || attachment.contentLength)
          attachment.previewURL = $utils.$attachment.getPreviewUrl({ mid: mid, part: attachment.id })
          attachment.formattype = $utils.$attachment.getIconClass(attachment.filename, attachment.contentType)
          attachment.extName = $utils.$attachment.getExtName(attachment.filename)
          attachment.downloadURL = mailService.getDownloadURL(mid, attachment.id) + '&filename=' + encodeURIComponent(attachment.filename)
          attachment.isPreview = $utils.$attachment.isSupportPreview(attachment.filename)
          if (mboxa) {
            attachment.previewURL += '&mboxa=' + mboxa
            attachment.downloadURL += '&mboxa=' + mboxa
          }
          if (mailCipherPassword) {
            attachment.mailCipherPassword = mailCipherPassword
            attachment.downloadURL = attachment.downloadURL.replace('func=mbox:getMessageData', 'func=mbox:decryptMessagePart')
            attachment.downloadURL += '&password=' + mailCipherPassword
            attachment.isPreview = false
          }
        }
      }
      return attachments
    }

    // 会议邀请邮件
    function _formatCalendar(calendar) {
      const requestMethod = calendar.meetingRequestMethod
      calendar.isMeetingRequest = requestMethod === 'request'
      const meetingRequest = calendar.meetingRequest || {}
      const attendees = meetingRequest.attendees || []
      let requestStatus = calendar.meetingRequestStatus
      const replyStatus = {
        2: $translate.instant('OP.TENTATIVE'),
        3: $translate.instant('OP.ACCEPT'),
        4: $translate.instant('OP.DECLINE')
      }
      calendar.isMembers = calendar.isAttendee || calendar.isOrganizer
      calendar.enableMeetingAction = calendar.isMeetingRequest && calendar.isAttendee

      if (requestMethod === 'reply') {
        calendar.statusDisplay = $translate.instant('MEETING_STATUS_' + requestStatus).replace('{0}', $utils.$html.encode(calendar.meetingRequestAttendee))
      } else if (requestMethod === 'cancel') {
        calendar.statusDisplay = $translate.instant('MEETING_CANCEL').replace('{0}', $utils.$html.encode(meetingRequest.organizer))
      }

      // TODO: 已经拒绝的日程邀请没有requestStatus(无法确认是否旧版本wmsvr会如此返回，先保留之前代码的兼容处理)
      if (angular.isUndefined(requestStatus)) requestStatus = 4
      //  被邀请者对信件的反馈 接受、待定、拒绝
      if (calendar.enableMeetingAction && replyStatus[requestStatus]) {
        calendar.participationDisplay = $translate.instant('MEETING_PARTICIPATION_DISPLAY').replace('{0}', replyStatus[requestStatus])
      }

      calendar.attendees = []
      for (let i = 0; i < attendees.length; i++) {
        calendar.attendees.push(attendees[i].email)
      }

      _formatCalendarTime(calendar)
      return calendar
    }

    // 格式化会议时间
    function _formatCalendarTime(calendar) {
      const user = User.getCurrentUser() || {}
      let userTimeZone = user.config.time_zone
      const meetingRequest = calendar.meetingRequest || {}
      const meetingStart = meetingRequest.start.replace(/-/g, '/') // 该时间是根据用户配置的时区对应的
      const duration = meetingRequest.duration || 0
      const isAllDayEvent = meetingRequest.allDayEvent
      const recurrence = meetingRequest.recurrence || '' // 循环事件
      let recurrenceTime = ''
      const startDate = new Date(meetingStart.toString())
      const durationDate = new Date()
      const weekDays = []
      let endDate

      if (meetingStart.indexOf(':') == -1) { // 没有 HH:MM:SS
        startDate.setHours(0)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
      }
      durationDate.setTime(startDate.getTime() + duration * 1000)

      endDate = durationDate
      if (isAllDayEvent && duration > 0 && duration % (24 * 60 * 60) == 0) {
        endDate.setTime((startDate.getTime() + duration * 1000) - 1)
      }

      /**
       * 普通跨天事件
       * 格式 2016年1月6日 星期三 下午17:00-2016年1月7日 星期四 下午18:00
       * */
      meetingRequest.startDate = $utils.$date.getTextFull(startDate)
      meetingRequest.endDate = $utils.$date.getTextFull(endDate)

      /**
       * 同一天
       * 格式 2016年1月6日 星期三 上午11:00  - 下午 23:00
       * */
      if ($utils.$date.isSameDate(startDate, endDate)) {
        meetingRequest.endDate = $utils.$date.getTimeAMPM(endDate)
      }

      /**
       * 全天事件
       * 格式 2016年1月6日 星期三(全天) or 2016年1月7日 星期四-2016年1月8日 星期五(全天)

        * */
      if (isAllDayEvent) {
        meetingRequest.startDate = $utils.$date.getDateString(startDate) + ' ' + $utils.$date.getTextDay(startDate)
        if ($utils.$date.isSameDate(startDate, endDate)) {
          meetingRequest.endDate = ''
        } else {
          meetingRequest.endDate = $utils.$date.getDateString(endDate) + ' ' + $utils.$date.getTextDay(endDate)
        }
      }

      /**
       * 循环事件
       * 格式 2016年1月6日 - 2016年1月17日 每天上午11:00 - 下午13:00
       * */
      if (recurrence) {
        endDate = recurrence.until ? new Date(recurrence.until.toString()) : endDate
        meetingRequest.startDate = $utils.$date.getDateString(startDate)
        meetingRequest.endDate = $utils.$date.getDateString(endDate)
        if (recurrence.dayOfWeek) { // 每周重复
          for (let i = 0; i < 7; i++) {
            if ((recurrence.dayOfWeek & (1 << i)) != 0) {
              weekDays.push($translate.instant('CA_DAY_' + i))
            }
          }
        }

        if (recurrence.monthOfYear) { // 每月（哪月）
          if ($translate.use() === 'zh_CN') {
            recurrenceTime = recurrenceTime + recurrence.monthOfYear + $translate.instant('CA_MONTH')
          } else {
            recurrenceTime = recurrenceTime + $translate.instant('CA_SHORTMONTH_' + recurrence.monthOfYear)
          }
        }
        if (recurrence.dayOfMonth) { // 哪天
          if ($translate.use() === 'zh_CN') {
            recurrenceTime = recurrenceTime + recurrence.dayOfMonth + $translate.instant('CA_DAY')
          } else {
            recurrenceTime = recurrenceTime + recurrence.dayOfMonth
          }
        }

        if (recurrence.weekOfMonth) {
          recurrenceTime = recurrence.weekOfMonth
        }

        meetingRequest.recurrenceTime = ($translate.instant('CA_RECURRENCE_TYPE' + recurrence.type) || '') +
          recurrenceTime + weekDays.join(',') +
          (isAllDayEvent ? '' : ($utils.$date.getTimeAMPM(startDate) + ' - ' + $utils.$date.getTimeAMPM(durationDate))) +
          ((!recurrence.until && !recurrence.occurrences) ? ' ' + $translate.instant('CA_RECURRENCE_FOREVER') : '')
      }

      const timeZoneValues = { //  应从用户配置 ajc.user.timeZoneValues 获取，由于获取配置数据方案还没确定，暂时从用户属性time_zone获取
        '0': 'UTC',
        '-12': 'UTC-1200',
        '-11': 'UTC-1100',
        '-2': 'UTC-0200',
        '+12': 'UTC+1200'
      }

      if (userTimeZone) {
        // 当前用户配置时区
        meetingRequest.timeZone = '(' + (timeZoneValues[userTimeZone] || userTimeZone) + ')'
      } else {
        User.getAttrs(User.getCurrentUser().sid).then(function () {
          userTimeZone = user.config.time_zone
          if (userTimeZone) {
            meetingRequest.timeZone = '(' + (timeZoneValues[userTimeZone] || userTimeZone) + ')'
          }
        })
      }
    }

    /**
     * 获取单封邮件
     * @param params
     */
    function readMessage(options) {
      // 优先获取服务器的，若服务器获取失败则获取缓存的，实现离线可看
      const enableMailCache = $rootScope.settings.enableMailCache
      return getServerMail(options).then(res => {
        enableMailCache && setCacheMail(res)
        return res
      }).catch(err => {
        return enableMailCache ? getCacheMail(options.id).catch(_ => $q.reject(err)) : $q.reject(err)
      })
    }

    /**
     * @function 设置单封缓存邮件
     * @param {object} mail 邮件
     */
    function setCacheMail(mail) {
      if (!mail && !mail.id) return false

      return getCacheMail(mail.id).then(cache => {
        cache = cache || {}
        // 大于设置的最大值，随机删除一个 key
        if (size(cache) >= $rootScope.settings.mailCacheLimit) {
          const cacheKeys = keys(cache)
          const random = Math.round(Math.random() * (cacheKeys.length - 1))
          delete cache[cacheKeys[random]]
        }
        cache[mail.id] = mail
        return IndexedDB.setItem('mail_detail_cache', cache)
      })
    }

    /**
     * @function 获取单封缓存邮件
     * @param {string} mid 邮件id
     */
    function getCacheMail(mid) {
      return IndexedDB.getItem('mail_detail_cache').then(cache => {
        cache = cache || {}
        return cache[mid] || $q.reject('cache not found')
      })
    }
    /**
     * @function 从服务器获取单封邮件
     * @param {string} mid 邮件id
     */
    function getServerMail(options) {
      const p1 = mailService.readMessage(options)
      const p2 = mailService.getMessageInfos({
        ids: options.id,
        mboxa: options.mboxa || '',
        summaryWindowSize: 1
      })
      return $q.all([p1, p2]).then(res => {
        const mail = res[0]
        const aMailsInfo = res[1]
        const mailInfo = aMailsInfo[0]

        angular.extend(mail.flags, mailInfo.flags)
        mail.encpwd = mailInfo.encpwd // 已发送邮件 显示普通加密密码
        mail.id = mailInfo.id
        mail.fid = mailInfo.fid
        mail.priority = mailInfo.priority // 优先级
        mail.summary = mailInfo.summary // 邮件摘要
        mail.mode = mail.html ? 'html' : 'text'
        mail.isAudit = !!mailInfo.orgauditinfo
        mail.delegatedSender = mailInfo.delegatedSender
        mail.isAudit && (mail.orgauditinfo = mailInfo.orgauditinfo)

        return _initMailBody(options, mail)
      })
    }
    /** 保存到个人网盘
     *  fid 文件夹id
     *  parts {array}  mid/attachments.id
     * **/
    function saveMessageToNF(options) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:saveMessageToNF',
          sid: User.getCurrentUser().sid
        },
        data: {
          fid: options.fid,
          parts: options.parts
        }
      }).then(function (data) {
        deferred.resolve(data)
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }

    /**
     *  解密信件结构
     *  .response code:
     *     S_OK                        解密成功
     *     FA_MAIL_NOT_FOUND           信件不存在
     *     FA_PART_NOT_FOUND           信件Part不存在
     *     FA_INVALID_PART             信件Part不是嵌套信
     *     FA_EMPTY_PASSWORD           没有传递密码参数
     *     FA_INVALID_PASSWORD         密码错误
     *     FA_INVALID_ENCRYPTED_DATA   数据错误
     * */

    function decryptMessage(options, params) {
      const deferred = $q.defer()
      params = angular.extend({
        autoName: true, mode: 'html'
      }, params)
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:decryptMessage',
          sid: User.getCurrentUser().sid
        },
        data: params
      }).then(function (result) {
        let mail = {}
        if (result['code'] == 'S_OK') {
          mail = result['var']
          mail.mailContent = _getMailContent(mail)
          options.mailCipherPassword = params.password
          angular.forEach(mail.attachments || [], item => (item.attsize = item.contentLength))
          _formatAttachments(options, mail.attachments)
          deferred.resolve(mail)
        }
      }, function (result) {
        result = result || {}
        switch (result.code) {
          case 'FA_MAIL_NOT_FOUND':
            result.message = $translate.instant('READ.FA_MAIL_NOT_FOUND')
            break
          case 'FA_EMPTY_PASSWORD':
            result.message = $translate.instant('READ.ERR_PASSWORD_EMPTY')
            break
          case 'FA_INVALID_PASSWORD':
            result.message = $translate.instant('READ.ERR_PASSWORD_INVALID')
            break
        }
        deferred.reject(result.message)
      })
      return deferred.promise
    }

    // 审核邮件
    function handleAudit(params) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'pub:audit',
          sid: User.getCurrentUser().sid
        },
        data: params
      }).then(function (data) {
        deferred.resolve(data)
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }

    // 共享邮件
    function shareBindMessage(options) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:shareBindMessage',
          sid: User.getCurrentUser().sid
        },
        data: options
      }).then(function (data) {
        deferred.resolve(data)
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }
    // 投递状态
    function getDeliveryStatus(options) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'user:listDeliveryHistory',
          sid: User.getCurrentUser().sid
        },
        data: options
      }).then(function (data) {
        deferred.resolve(data)
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }
    // 召回邮件
    function recallMail(options) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:recallMessage2',
          sid: User.getCurrentUser().sid
        },
        data: options
      }).then(function (data) {
        deferred.resolve(data)
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }
    // 接受\待定\拒绝 会议邀请
    function replyMeetingRequest(params) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'cal:replyMeetingRequest',
          sid: User.getCurrentUser().sid
        },
        data: params
      }).then(function (data) {
        deferred.resolve(data)
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }

    // 添加到我的日程
    function addToMyCal(params) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'cal:addToMyCal',
          sid: User.getCurrentUser().sid
        },
        data: params
      }).then(function (data) {
        deferred.resolve(data)
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }

    // 删除日程
    function delFromMyCal(params) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'cal:delFromMyCal',
          sid: User.getCurrentUser().sid
        },
        data: params
      }).then(function (data) {
        deferred.resolve(data)
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }
    // 获取网盘文件详情
    function getFileInfo(fid) {
      const deferred = $q.defer()
      const params = {
        ids: [fid]
      }
      Promise.wmcall('nf:getFileInfos', params).then(function (res) {
        if (res.code === 'S_OK') {
          deferred.resolve(res.var)
        }
      }, function () {
        deferred.reject()
      })
      return deferred.promise
    }

    // 回复邮件
    function replyMessage({id, toAll, subject, quoteHTMLStart, quoteHTMLEnd, mboxa}) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:replyMessage',
          sid: User.getCurrentUser().sid
        },
        data: {
          id: id,
          toAll: toAll,
          action: 'deliver',
          quoteTextLinePrefix: true,
          withAttachments: false,
          attrs: {
            subject: subject,
            isHtml: true
          },
          quoteHTMLStart: quoteHTMLStart,
          quoteHTMLEnd: quoteHTMLEnd,
          mboxa
        }
      }).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          deferred.resolve(data['var'] || {})
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    return {
      readMessage: readMessage,
      shareBindMessage: shareBindMessage,
      saveMessageToNF: saveMessageToNF,
      decryptMessage: decryptMessage,
      replyMeetingRequest: replyMeetingRequest,
      addToMyCal: addToMyCal,
      delFromMyCal: delFromMyCal,
      getDeliveryStatus: getDeliveryStatus,
      recallMail: recallMail,
      handleAudit: handleAudit,
      getFileInfo: getFileInfo,
      replyMessage: replyMessage
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/read/readService.js